import type { MenusDisplayType } from '../../types/menus';

export const canDisplayMenuItem = {
  renderIcon: (displayType: MenusDisplayType) => displayType === 'Icon' || displayType === 'ImageAndIcon',
  renderImage: (displayType: MenusDisplayType) => displayType === 'Image' || displayType === 'ImageAndIcon',
};
